export interface FailedTestSummary {
  total: number;
  critical: number;
  nonCritical: number;
}

// testTabData is an array of { [group]: failedTest[] } entries (one per
// partner/test group), each failed test flagged with isCriticalTest — see
// pages/Loans/v1/Common.tsx. Only failed tests are present in it.
export const getFailedTestSummary = (testTabData: any[] | undefined): FailedTestSummary => {
  let critical = 0;
  let nonCritical = 0;
  (Array.isArray(testTabData) ? testTabData : []).forEach((entry) => {
    Object.values(entry ?? {}).forEach((tests) => {
      if (!Array.isArray(tests)) return;
      tests.forEach((test: any) => {
        if (test?.isCriticalTest) critical += 1;
        else nonCritical += 1;
      });
    });
  });
  return { total: critical + nonCritical, critical, nonCritical };
};

export const FAILED_TESTS_CHIP_PREFIX = "Failed Tests: ";

// e.g. "Failed Tests: 2 Critical · 1 Non Critical" — a part is omitted when zero.
export const formatFailedTestsChip = (summary: FailedTestSummary): string =>
  FAILED_TESTS_CHIP_PREFIX +
  [
    summary.critical ? `${summary.critical} Critical` : "",
    summary.nonCritical ? `${summary.nonCritical} Non Critical` : "",
  ]
    .filter(Boolean)
    .join(" · ");
